import React from "react";

const ApprovalsIcon = ({ size = 12, color = "none", className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 13"
    fill={color}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.26836 1.48282C5.43567 1.31539 5.70705 1.31528 5.87445 1.48259L7.16218 2.76929C7.24266 2.84971 7.28783 2.95883 7.28779 3.07262C7.28775 3.18639 7.24249 3.29549 7.16192 3.37585L5.87423 4.66057C5.70666 4.82775 5.43529 4.82745 5.26815 4.65987C5.10096 4.49231 5.10126 4.22096 5.26883 4.05378L5.81946 3.50444C3.89148 3.59859 2.35725 5.19156 2.35725 7.14289C2.35725 9.15478 3.98821 10.7857 6.0001 10.7857C7.94706 10.7857 9.53753 9.25815 9.6379 7.33639C9.65025 7.09999 9.85189 6.91841 10.0882 6.93075C10.3246 6.94309 10.5062 7.14473 10.4939 7.38109C10.3699 9.75585 8.4055 11.6429 6.0001 11.6429C3.51482 11.6429 1.5001 9.62818 1.5001 7.14289C1.5001 4.71581 3.42157 2.7375 5.82632 2.64619L5.26862 2.08891C5.10117 1.92161 5.10109 1.65025 5.26836 1.48282Z"
      stroke="currentColor"
      strokeWidth="0.05"
      fill="currentColor"
    />
    <path
      d="M7.80315 5.76834C7.9705 5.9357 7.9705 6.20707 7.80315 6.37443L5.66029 8.51728C5.57993 8.59764 5.4709 8.64281 5.35725 8.64281C5.24359 8.64281 5.13456 8.59764 5.0542 8.51728L4.19706 7.66014C4.02969 7.49278 4.02969 7.22141 4.19706 7.05405C4.36442 6.8867 4.63579 6.8867 4.80315 7.05405L5.35725 7.60815L7.19706 5.76834C7.36442 5.60098 7.63579 5.60098 7.80315 5.76834Z"
      stroke="currentColor"
      strokeWidth="0.05"
      fill="currentColor"
    />
  </svg>
);

export default ApprovalsIcon;
